module.exports = __webpack_public_path__ + "static/media/8300.a2e7ab01.jpg";